module.exports = __webpack_public_path__ + "img/newBg.5ae6099d.png";